import BaseApi from '@/api/controller/base';

const API_URL = 'user';

class DocutaxNotificationSettingApi extends BaseApi {
  constructor() {
    super(API_URL);
  }

  findByUserId(userId) {
    return this.api.get(`${userId}/docutax-notification-setting`);
  }

  save(userId, setting) {
    return this.api.post(`${userId}/docutax-notification-setting`, setting);
  }
}

const apiInstance = new DocutaxNotificationSettingApi();
export { DocutaxNotificationSettingApi, apiInstance };
export default apiInstance;
